import React from 'react';
import PropTypes from 'prop-types';
import Validator from '../../../shared/validator';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import Loading from '../../../shared/loading';
import mutate from '../../../shared/mutate';
import Category from './category';
import { getById } from '../../../services/lwadmin/category/category-service';

export default class EditCategoryModal extends React.Component {
  static propTypes = {
    categoryDidSave: PropTypes.func.isRequired,
  }

  constructor(props, context) {
    super(props, context);

    this.validator = new Validator({
      nameRequired: state => !!state.category.name,
    });
    this.state = {
      category: new Category(),
      validations: this.validator.getValidations(),
    };
  }

  componentDidMount() {
    const self = this;

    this.$modal.click(function onClick(e) {
      if (e.target === this) self.dismiss();
    });
  }

  handleNameChange(e) {
    const name = e.target.value;

    this.setState(oldState => mutate(oldState, state => {
      state.category.name = name;
      state.validations.nameRequiredValid = this.validator.validateNameRequired(state);
    }));
  }

  handleDescriptionChange(e) {
    const description = e.target.value;

    this.setState(oldState => mutate(oldState, state => {
      state.category.description = description;
    }));
  }

  save() {
    this.setState(
      state => ({
        validations: this.validator.validateForm(state),
      }),
      () => {
        if (!this.validator.formValid) return;

        this.loading.start();
        this.state.category
          .save()
          .then(result => {
            this.dismiss();
            this.props.categoryDidSave && this.props.categoryDidSave(new Category(result.data));
          })
          .catch(error => defaultOnErrorHandler(error, 'Error saving category'))
          .finally(() => this.loading.stop());
      },
    );
  }

  regenerateSlug() {
    this.loading.start();
    this.state.category
      .regenerateSlug()
      .then(result => {
        this.setState(oldState => mutate(oldState, state => {
          state.category = new Category(result.data.category);
        }));
      })
      .catch(error => defaultOnErrorHandler(error, 'Error regenerating slug'))
      .finally(() => this.loading.stop());
  }

  present(categoryId = null) {
    this.validator.resetValidation();
    this.setState({ validations: this.validator.getValidations() });
    this.$overlay.fadeIn();
    this.$modal.fadeIn();
    this.$categoryNameInput.focus();

    if (categoryId === null) {
      this.setState({ category: new Category() });
    } else {
      this.loading.start();
      getById(categoryId)
        .then(result => this.setState({ category: new Category(result.data.category) }))
        .catch(error => defaultOnErrorHandler(error, 'Error loading category'))
        .finally(() => this.loading.stop());
    }
  }

  dismiss() {
    this.$overlay.fadeOut();
    this.$modal.fadeOut();
  }

  render() {
    return (
      <div>
        <div className="modal-overlay" role="region" ref={el => (this.$overlay = $(el))} onClick={() => (this.dismiss())} />
        <div className="modal --large" tabIndex="-1" role="dialog" ref={el => (this.$modal = $(el))}>
          <article>
            <header>
              <h4>
                {!!this.state.category.id && <span>Editing a category</span>}
                {!!this.state.category.id || <span>Create a new category</span>}
              </h4>
            </header>
            <Loading ref={c => (this.loading = c)}>
              <section className="modal-columnar-container">
                <section>
                  <p className={`form-group ${this.state.validations.nameRequiredValid ? '' : 'has-error'}`}>
                    <label htmlFor="name">
                      Name:
                      <input
                        id="name"
                        type="text"
                        placeholder="Category name"
                        ref={el => (this.$categoryNameInput = $(el))}
                        value={this.state.category.name}
                        onChange={e => this.handleNameChange(e)}
                      />
                    </label>
                    {this.state.validations.nameRequiredValid || <span className="help-block">Category name is required</span>}
                  </p>
                  <p className="form-group">
                    <label htmlFor="description">
                      Description:
                      <input
                        id="description"
                        type="text"
                        placeholder="Category description"
                        value={this.state.category.description}
                        onChange={e => this.handleDescriptionChange(e)}
                      />
                    </label>
                  </p>
                  {!!this.state.category.id && (
                  <div className="form-group">
                    <label htmlFor="slug">
                      {'Slug: '}
                      <span id="slug">{this.state.category.slug}</span>
                    </label>
                  </div>
                  )}
                </section>
              </section>
              <footer>
                {!!this.state.category.id && <button type="button" className="btn" onClick={() => this.regenerateSlug()}>Regenerate Slug</button>}
                <button type="button" className="btn btn-secondary" onClick={() => this.dismiss()}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={() => this.save()}>Save</button>
              </footer>
            </Loading>
          </article>
        </div>
      </div>
    );
  }
}
